export default "__VITE_ASSET__BmEGe82R__"